import { account, personalProfessional, review } from '../steps'

export default [account, personalProfessional, review]
